import React from "react";

const BahriaOrchard = () => {
  // Additional images for Bahria Orchard-4 School
  const additionalImages = [
    "/images/Picture8.jpg",
    "/images/Picture70.jpg",
    "/images/Picture9.jpg",
  ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">Bahria Orchard-4 School, Lahore</h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Construction Services by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            Below is a list of the project details for the Bahria Orchard-4 School, where <strong>PACIFIC BUILDERS (PVT) LTD</strong> has executed high-standard construction work with an emphasis on precision and quality.
          </p>

          <div className="text-lg text-gray-700">
            <p><strong>Scope of Work:</strong> Structural works</p>
            <p><strong>Architect:</strong> Design wing, Bahria Town</p>
            <p><strong>Project Description:</strong> Bahria Orchard-4 School is an educational institution located in Bahria Orchard-4, Lahore.</p>
            <p><strong>Location:</strong> Bahria Orchard-4, Lahore, Pakistan</p>
            <p><strong>Client:</strong> Bahria Town (PVT) LTD</p>
            <p><strong>Status:</strong> Complete</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture7.jpg"
            alt="Bahria Orchard-4 School Construction"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Bahria Orchard-4 School ${index + 1}`}
              className="w-full h-[200px] rounded shadow"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BahriaOrchard;
